import { EventSystem, IEventSystem } from "@dhx/ts-common/events";
import { SelectionEvents } from "@dhx/ts-common/types";
import { DataCollection } from "./datacollection";
import { DataEvents } from "./types";

export class Selection{
	public events : IEventSystem<SelectionEvents>;

	private _selected : string;
	private _data:DataCollection;

	constructor(_config:any, data?:DataCollection, events?:IEventSystem<any>){
		this.events = events || (new EventSystem<any>(this));
		this._data = data;

		this._data.events.on(DataEvents.removeAll, () => {
			this._selected = null;
		});
		this._data.events.on(DataEvents.change, () => {
			if (this._selected){
				const near = this._data.getNearId(this._selected);
				if (near !== this._selected){
					this._selected = null;
					if (near){
						this.add(near);
					}
				}
			}
		});
	}

	getId(): string {
		return this._selected;
	}

	getItem():any {
		if (this._selected){
			return this._data.getItem(this._selected);
		}
		return null;
	}

	remove(id?: string): boolean {
		id = id || this._selected;
		if (!id){
			return true;
		}
		if (this.events.fire(SelectionEvents.beforeUnSelect, [id])) {
			this._data.update(id, { $selected: false });
			this._selected = null;
			this.events.fire(SelectionEvents.afterUnSelect, [id]);
			return true;
		}
		return false;
	}

	add(id: string) {
		if (this._selected === id) { return; }
		this.remove();

		if (this.events.fire(SelectionEvents.beforeSelect, [id])) {
			this._selected = id;
			this._data.update(id, { $selected: true });
			this.events.fire(SelectionEvents.afterSelect, [id]);
		}
	}
}

